import { ChakraFlex, ChakraText } from '@equip.health/ui';

interface SupportLinkedAccountsTextProps {
  linkedAccountsCount?: number;
  marginBottom?: string;
  onClick: () => void;
  paddingLeft?: string;
  paddingTop?: string;
  topLevelId: string;
}

const SupportLinkedAccountsText = ({
  linkedAccountsCount,
  marginBottom,
  onClick,
  paddingLeft,
  paddingTop,
  topLevelId,
}: SupportLinkedAccountsTextProps) => {
  if (linkedAccountsCount === 0) {
    return null;
  }
  return (
    <ChakraFlex
      alignItems="center"
      marginBottom={marginBottom}
      paddingLeft={paddingLeft}
      paddingTop={paddingTop}
    >
      <ChakraText color="neutral.secondary" fontSize="12px" paddingRight="4px">
        Has access to
      </ChakraText>
      <ChakraText
        as="button"
        color="primary.100"
        fontSize="12px"
        id={`${topLevelId}__linked-accounts-count`}
        onClick={onClick}
      >{`${linkedAccountsCount} patient app accounts`}</ChakraText>
    </ChakraFlex>
  );
};

export default SupportLinkedAccountsText;
